import axios, { isCancel } from 'axios';

const { REACT_APP_CMS_URL, REACT_APP_WB_BACKEND_URL, REACT_APP_ACCEPT_HEADER_WB } = process.env;

// ========================================
// Instance Axios pour CMS Strapi
// ========================================
export const cmsAxios = axios.create({
  baseURL: REACT_APP_CMS_URL,
  timeout: 60000, // 60 secondes
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  withCredentials: false, // Important pour CORS
});

// Intercepteur pour ajouter le token JWT (CMS)
cmsAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Intercepteur pour gérer les erreurs (CMS)
cmsAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Meilleure gestion des erreurs réseau
    if (!error.response) {
      // Erreur réseau ou CORS
      console.error('CMS Network Error:', error.message);
      error.message = 'Impossible de se connecter au serveur CMS. Vérifiez votre connexion.';
    }
    return Promise.reject(error);
  },
);

// ========================================
// Instance Axios pour Backend Microservices
// ========================================
export const backendAxios = axios.create({
  baseURL: REACT_APP_WB_BACKEND_URL,
  timeout: 60000, // 60 secondes
  headers: {
    'Content-Type': 'application/json',
    Accept: REACT_APP_ACCEPT_HEADER_WB,
  },
  withCredentials: false, // Important pour CORS
});

// Interceptor pour ajouter le token
backendAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if(token) {
        const newConfig = { ...config, headers: { ...config.headers } };
        newConfig.headers.Authorization = `Bearer ${token}` ;
        return newConfig;
    }
    return config;
   },
   (error) => Promise.reject(error),
);
 
// Intercepteur pour gérer les erreurs (Backend)
backendAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isCancel(error)) {
      return Promise.reject(error);
    }
    if (!error.response) {
      console.error('Backend Network Error:', error.message);
      error.message = 'Impossible de se connecter au backend. Vérifiez votre connexion.';
    }
    return Promise.reject(error);
  },
);

// Export par défaut pour la rétrocompatibilité
export default cmsAxios;

